import { FunctionComponent } from 'react';

import { pageTitle } from '~/client/utils/string';

type Props = {
  title?: string;
};

export const PageTitle: FunctionComponent<Props> = ({ title }) => <title>{pageTitle(title)}</title>;
